import FileHandler from '@tiptap/extension-file-handler';
import { Editor, Extensions } from '@tiptap/react';

import { ImageUploadNode } from 'containers/Tiptap/components/tiptap-node/image-upload-node';
import { Attachment } from 'containers/Tiptap/components/tiptap-node/attachment-node';
import { MAX_DOCUMENT_IMAGE_SIZE, handleImageUpload } from 'containers/Tiptap/lib/tiptap-utils';
import { uploadAttachmentFunction } from 'containers/Tiptap/components/tiptap-node/attachment-node/utils';
import Logger from 'utils/logger';

export interface MediaExtensionsOptions {
  entityId: string;
  editable: boolean;
  onError?: (message: string) => void;
}

export function createMediaExtensions(options: MediaExtensionsOptions): Extensions {
  const { entityId, editable, onError } = options;

  const extensions: Extensions = [Attachment];

  if (editable) {
    const fileHandlerExtension = FileHandler.configure({
      onDrop: (currentEditor: Editor, files: File[], pos: number) =>
        uploadAttachmentFunction(currentEditor, files, pos, entityId, onError || (() => {})),
    });

    extensions.push(
      fileHandlerExtension,
      ImageUploadNode.configure({
        accept: '*/*',
        maxSize: MAX_DOCUMENT_IMAGE_SIZE,
        limit: 5,
        upload: handleImageUpload,
        onError: (error: Error) => Logger.error('Upload failed:', error),
      })
    );
  }

  return extensions;
}
